module.exports = __webpack_public_path__ + "static/img/cont2.4ac9a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2.jpg
// module id = dPzA
// module chunks = 0